import { toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Global toast configuration with valid position string literals
const toastOptions: ToastOptions = {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    rtl: false,
    draggable: true,
    pauseOnHover: true,
    style: {
        whiteSpace: 'nowrap', // Force the message to stay on one line
        width: 'fit-content'  // Ensure the width adjusts to the content
    },
};

// Toast success notification
export const showSuccessToast = (message: string) => {
    toast.success(message, toastOptions);
};

// Toast error notification
export const showErrorToast = (message: string) => {
    toast.error(message, toastOptions);
};

// Toast info notification (optional)
export const showInfoToast = (message: string) => {
    toast.info(message, toastOptions);
};

// Toast warning notification (optional)
export const showWarningToast = (message: string) => {
    toast.warn(message, toastOptions);
};
